module.exports = __webpack_public_path__ + "static/media/dashboardOrder_fr.d32c6251.png";